import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { authenticationFlowPaths } from "../../Routes/paths";
import { FORCED_AUTHENTICATION } from "../../util/constants";
import useAmplifyHub from "../../Common/hooks/useAmplifyHub";

/**
 * Handles the complete authentication flow as a non-blocking side effect.
 * Mirrors the honors-and-scholars pattern: the app shell renders immediately
 * while auth is checked in the background. Individual routes gate on auth
 * status via their own checks (see RenderableView).
 */
function useCompleteAuthFlowHandler() {
  const location = useLocation();
  const { handleSignIn } = useAmplifyHub();
  const onAuthPage = authenticationFlowPaths
    .map(({ path }) => path)
    .includes(location.pathname);

  const authCheckInitiated = useRef(false);

  useEffect(() => {
    if (!onAuthPage && !authCheckInitiated.current) {
      authCheckInitiated.current = true;
      handleSignIn(
        `${location.pathname}${location.search || ""}${location.hash || ""}`,
        { doNotRedirect: !FORCED_AUTHENTICATION }
      );
    }
  }, [handleSignIn, onAuthPage, location.pathname, location.search, location.hash]);
}

export default useCompleteAuthFlowHandler;
